import { normalizeShippingPreferenceForSource } from './shipping';

const DEFAULT_SHIPPING_DIMENSIONS = Object.freeze({
  height: '1',
  length: '8.5',
  width: '11',
  weight: '1.2',
  unit: 'lb',
  distanceUnit: 'in',
});

export const hasStripeConnection = user => {
  if (!user.id) return false;
  return user?.attributes?.stripeConnected;
};
export const hasDefaultPaymentMethod = user => {
  if (!user.id) return false;
  return !!user?.stripeCustomer?.defaultPaymentMethod?.id;
};
export const getStripePaymentMethodId = user => {
  if (!user?.id) return null;
  return user?.stripeCustomer?.defaultPaymentMethod?.attributes?.stripePaymentMethodId;
};
export const getStripeCustomerId = user => {
  if (!user?.id) return null;
  return user?.stripeCustomer?.attributes?.stripeCustomerId;
};
export const getUserDisplayName = user => {
  if (!user.id) return null;
  return user?.attributes?.profile?.displayName;
};

export const getUserEmail = user => (user?.id?.uuid ? user.attributes?.email : null);

export const getUserPhoneNumber = user =>
  user?.id?.uuid ? user.attributes?.profile?.protectedData?.phoneNumber : null;

export const getDisplayName = user =>
  user?.id?.uuid ? user.attributes?.profile?.displayName : 'N/A';

export const getReturnParams = txn =>
  txn?.id?.uuid ? txn.attributes?.metadata?.returnParams : null;

export const getUserFullName = user => {
  if (!user?.id) return null;
  const { firstName, lastName, displayName } = user.attributes?.profile ?? {};
  return firstName && lastName ? `${firstName} ${lastName}` : displayName;
};

export const getShippingDetails = user =>
  user?.attributes?.profile?.protectedData?.shippingAddress ?? null;

export const getShippingPreference = user => {
  const { protectedData, publicData } = user?.attributes?.profile ?? {};

  return protectedData?.shippingPreference ?? publicData?.shippingPreference ?? null;
};

export const getNormalizedShippingPreference = (user, config, options) =>
  normalizeShippingPreferenceForSource(getShippingPreference(user), user, config, options);

export const getShippingDimensions = () => ({ ...DEFAULT_SHIPPING_DIMENSIONS });

export const getAddressObjectId = user =>
  user?.id ? user.attributes?.profile?.publicData?.addressObjectId : null;
